/*
 * This file is generated by the script generate-graphql.js
 */
export default {
  Abtest: { keyFields: false },
  AbtestCohort: { keyFields: false },
  AbtestCohortClassAttributeValue: { keyFields: false },
  AbtestCohortInstance: { keyFields: false },
  AbtestCohortOverride: { keyFields: false },
  ActionLog: { keyFields: false },
  ActionLogConnection: { keyFields: false },
  ActionLogEdge: { keyFields: false },
  ActionLogEntity: { keyFields: false },
  ActionLogMetadata: { keyFields: false },
  Class: { keyFields: false },
  ClassAttributeInfo: { keyFields: false },
  ClassAttributeValue: { keyFields: false },
  ClassInstance: { keyFields: false },
  ConfigurationClass: { keyFields: false },
  ConfigurationClassAttributeValue: { keyFields: false },
  ConfigurationRule: { keyFields: false },
  ConfigurationRuleInstance: { keyFields: false },
  ConfigurationRuleSchedule: { keyFields: false },
  ConfigurationRuleScheduleRange: { keyFields: false },
  ConfigurationSimulation: { keyFields: false },
  DeleteClassMutationErrorAbtestDetails: { keyFields: false },
  DeleteClassMutationResponse: { keyFields: false },
  DeleteFeatureMutationResponse: { keyFields: false },
  DeleteSegmentMutationErrorAbtestDetails: { keyFields: false },
  DeleteSegmentMutationResponse: { keyFields: false },
  DuplicateAbtestMutationResponse: { keyFields: false },
  ExportClassToCatalogMutationResponse: { keyFields: false },
  Feature: { keyFields: false },
  Game: { keyFields: false },
  GamePlatform: { keyFields: false },
  ImportClassesFromCatalogMutationErrorDetail: { keyFields: false },
  ImportClassesFromCatalogMutationResponse: { keyFields: false },
  InAppPurchase: { keyFields: false },
  Layer: { keyFields: false },
  Mutation: { keyFields: false },
  MutationResponse: { keyFields: false },
  Notification: { keyFields: false },
  PageInfo: { keyFields: false },
  Pricing: { keyFields: false },
  PublishVersionResponse: { keyFields: false },
  RawClass: { keyFields: false },
  RawInstance: { keyFields: false },
  RawInstanceValue: { keyFields: false },
  Sandbox: { keyFields: false },
  SaveAbtestMutationResponse: { keyFields: false },
  SaveAddTestDeviceMutationResponse: { keyFields: false },
  SaveClassMutationResponse: { keyFields: false },
  SaveFeatureMutationResponse: { keyFields: false },
  SaveLayerMutationResponse: { keyFields: false },
  Segment: { keyFields: false },
  SegmentCondition: { keyFields: false },
  StoreItem: {
    keyFields: "id",
    fields: {
      tags: {
        merge: (_existing: unknown, incoming: []) => incoming,
      },
    },
  },
  RewardItem: {
    keyFields: false,
  },
  ItemsSprite: {
    keyFields: false,
  },
  StoreItemsDeleteResponse: { keyFields: false },
  TestDevice: { keyFields: false },
  TestDeviceAssignation: { keyFields: false },
  User: { keyFields: false },
  UserPermission: { keyFields: false },
  Version: { keyFields: false },
};
